import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export async function listSessions(user_id) {
  const { data } = await api.get(`/sessions`, { params: { user_id } });
  return data;
}

export async function createSession(user_id, title = "New chat") {
  const { data } = await api.post(`/sessions`, { user_id, title });
  return data;
}

export async function renameSession(id, title) {
  const { data } = await api.patch(`/sessions/${id}`, { title });
  return data;
}

export async function deleteSession(id) {
  await api.delete(`/sessions/${id}`);
}

export async function getMessages(session_id) {
  const { data } = await api.get(`/sessions/${session_id}/messages`);
  return data;
}

export async function shareSession(session_id) {
  const { data } = await api.post(`/sessions/${session_id}/share`);
  return data;
}

export async function unshareSession(session_id) {
  const { data } = await api.post(`/sessions/${session_id}/unshare`);
  return data;
}

export async function getSharedChat(slug) {
  const { data } = await api.get(`/shared/${slug}`);
  return data;
}

export async function epcSearch(postcode, { size = 25, house_number, source, parent, user_id } = {}) {
  const params = { postcode, size };
  if (house_number && house_number.trim()) params.house_number = house_number.trim();
  if (source) params.source = source;
  if (parent) params.parent = parent;
  if (user_id) params.user_id = user_id;
  const { data } = await api.get(`/epc/search`, { params });
  return data;
}

export async function epcCertificate(certificateNumber, band) {
  const { data } = await api.get(`/epc/certificate/${certificateNumber}`, {
    params: band ? { band } : {},
  });
  return data;
}

/**
 * Stream a chat completion via SSE using fetch + ReadableStream.
 * onDelta(text) is called with each token chunk; onDone() when finished.
 */
export async function streamChat({ session_id, user_id, content, embed_mode, onDelta, onDone, onError }) {
  const res = await fetch(`${API}/chat/stream`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ session_id, user_id, content, embed_mode: !!embed_mode }),
  });
  if (!res.ok || !res.body) {
    const t = await res.text().catch(() => "");
    onError && onError(t || `HTTP ${res.status}`);
    return;
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder("utf-8");
  let buffer = "";
  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const parts = buffer.split("\n\n");
    buffer = parts.pop() || "";
    for (const part of parts) {
      const line = part.trim();
      if (!line.startsWith("data:")) continue;
      const jsonStr = line.slice(5).trim();
      if (!jsonStr) continue;
      try {
        const evt = JSON.parse(jsonStr);
        if (evt.type === "delta") onDelta && onDelta(evt.content);
        else if (evt.type === "done") onDone && onDone(evt);
        else if (evt.type === "error") onError && onError(evt.message);
      } catch {
        /* ignore parse errors */
      }
    }
  }
}
